import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    tile: 'bg-grey-80 hover:(b-black c-grey-20)',
  }
} satisfies VfConfig['tile']
